import React from "react";
import SmoothScroll from "./SmoothScroll";
import ParticleField from "./ParticleField";
import ScrollProgress from "./ScrollProgress";
import CvNavbar from "./Navbar";
import Hero from "./Hero";
import TheRide from "./TheRide";
import Story from "./Story";
import Timeline from "./Timeline";
import Education from "./Education";
import Sports from "./Sports";
import Experience from "./Experience";
import Projects from "./Projects";
import Skills from "./Skills";
import Credentials from "./Credentials";
import Geography from "./Geography";
import ValuesVision from "./ValuesVision";
import Moments from "./Moments";
import Awards from "./Awards";
import Contact from "./Contact";
import "./cv.css";

const CvPage = () => {
  return (
    <SmoothScroll>
      <div className="cv-root relative min-h-screen text-white" style={{ background: "#06070b" }}>
        {/* Ambient noise/grain overlay */}
        <div className="pointer-events-none fixed inset-0 z-[5] opacity-[0.04] mix-blend-overlay" style={{
          backgroundImage: "radial-gradient(rgba(255,255,255,0.4) 1px, transparent 1px)",
          backgroundSize: "3px 3px",
        }} />
        {/* Top vignette */}
        <div className="pointer-events-none fixed inset-x-0 top-0 h-40 z-[6] bg-gradient-to-b from-black/60 to-transparent" />

        <ParticleField />
        <ScrollProgress />
        <CvNavbar />

        <main className="relative z-10">
          <Hero />
          <TheRide />
          <Story />
          <Timeline />
          <Education />
          <Sports />
          <Experience />
          <Projects />
          <Moments />
          <Awards />
          <Credentials />
          <Skills />
          <Geography />
          <ValuesVision />
          <Contact />
        </main>
      </div>
    </SmoothScroll>
  );
};

export default CvPage;
